import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";

const URL = "https://breles-balades.fr";

const BrelesBalades = () => {
  return (
    <section data-testid="breles-section" id="breles" className="py-24 lg:py-32 bg-sable">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="rounded-[2rem] overflow-hidden shadow-[0_18px_45px_rgba(44,42,40,0.18)] order-2 lg:order-1"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_bourgogne-escargots/artifacts/bmu9wgnp_WhatsApp%20Image%202026-07-02%20at%2010.19.13%20%2814%29.jpeg"
              alt="Balade en mobylette vintage avec Les Brèles Balades"
              className="w-full h-[440px] object-cover"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="order-1 lg:order-2"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_bourgogne-escargots/artifacts/hnlh4woq_breles-balades-logo-original%402x.svg"
              alt="Logo Les Brèles Balades en Bourgogne"
              data-testid="breles-logo"
              className="h-24 w-auto"
            />
            <h2 className="font-heading text-4xl sm:text-5xl text-foreground mt-5 tracking-tight leading-tight">
              En mobylette vintage avec Les Brèles Balades
            </h2>
            <p className="text-lg text-foreground/75 mt-5 leading-relaxed">
              Notre ami Romuald, à Buxy, organise de savoureuses balades en mobylettes d'époque à
              travers les vignes de la Côte Chalonnaise. Au fil de la route, les Brèles font une halte
              chez nous pour une <strong className="text-foreground">visite du parc et une dégustation</strong> —
              le mariage parfait entre patrimoine roulant, terroir et gourmandise.
            </p>

            <a
              href={URL}
              target="_blank"
              rel="noreferrer"
              data-testid="breles-link"
              className="inline-flex items-center gap-2 mt-8 rounded-full bg-bordeaux text-white font-600 px-7 py-3.5 hover:bg-bordeaux-dark transition-all hover:-translate-y-0.5"
            >
              Découvrir Les Brèles Balades <ExternalLink size={17} />
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default BrelesBalades;
